import React, {PureComponent} from 'react';

interface IBookingSearchBarState {
}

export class BookingSearchBar extends PureComponent<any, IBookingSearchBarState> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    render() {

        return (
            <div className="bar-position">
                <h2 className='text-light'>
                    Broneeringud
                </h2>
                <div className="card mb-5">
                    <div className="card-body">
                        <div className='d-flex flex-wrap flex-md-nowrap flex-column flex-md-row'>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
